import request from '@/utils/httpRequest'

export default class ExtensionSurveyService {
    queryById(id) {
        return request({
            url: '/extension/wuyeExtensionSurvey/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/extension/wuyeExtensionSurvey/startFlow',
            method: 'post',
            data: params
        })
    }

}
